module.exports = __webpack_public_path__ + "static/s2-2-confusing-d-bac9c09b2e883173f9e008f5b49c4649.jpg";